import { extractApiErrorMessage } from "@velizhanin-dev/api-errors"
import { Send } from "lucide-react"
import { useEffect, useState } from "react"
import { toast } from "sonner"
import { requestTelegramLink, useSession } from "@/entities/session"
import { cn } from "@/shared/lib/utils"

/**
 * Привязка Telegram к учётной записи сотрудника: открывает бота с кодом, а когда
 * человек возвращается во вкладку, профиль перечитывается сам.
 */
export function LinkTelegramButton({ className, label }: { className: string; label: React.ReactNode }) {
	const { user, refreshUser } = useSession()
	const [waiting, setWaiting] = useState(false)

	useEffect(() => {
		if (!waiting) return
		const onFocus = () => void refreshUser()
		window.addEventListener("focus", onFocus)
		return () => window.removeEventListener("focus", onFocus)
	}, [waiting, refreshUser])

	useEffect(() => {
		if (waiting && user?.telegramId) {
			setWaiting(false)
			toast.success("Telegram привязан")
		}
	}, [waiting, user?.telegramId])

	if (!user || user.telegramId) return null

	return (
		<button
			type="button"
			title="Чтобы входить без пароля и получать проверки рассылок и итоги в Telegram"
			className={cn(className, "text-primary hover:bg-secondary/50")}
			onClick={async () => {
				const opened = window.open("", "_blank")
				try {
					const { url } = await requestTelegramLink()
					if (opened) opened.location.href = url
					else window.location.href = url
					setWaiting(true)
				} catch (error) {
					opened?.close()
					toast.error(extractApiErrorMessage(error, "Не удалось начать привязку"))
				}
			}}
		>
			<Send className="size-4 shrink-0" />
			{label}
		</button>
	)
}
